// extracted by mini-css-extract-plugin
export default {"progressbar":"ProgressBar_progressbar__01V9S","text":"ProgressBar_text__HyQ6N"};